/**
 * Last-N rounds strip (classic crash-game furniture): local, per-browser, purely
 * cosmetic — gives the pattern-seeking itch something to chew on between rounds.
 */
export interface PastRound {
  /** Where the round crashed. */
  cp: number;
  /** Multiplier the player locked, or null if they rode it into the ground. */
  cashed: number | null;
}

const KEY = "kp:crash:history";
export const HISTORY_LEN = 8;

export function loadHistory(): PastRound[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return [];
    return arr
      .filter(
        (r): r is PastRound =>
          typeof r === "object" &&
          r !== null &&
          typeof (r as PastRound).cp === "number",
      )
      .slice(0, HISTORY_LEN);
  } catch {
    return [];
  }
}

export function pushHistory(round: PastRound): PastRound[] {
  const next = [round, ...loadHistory()].slice(0, HISTORY_LEN);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage blocked — strip just won't persist */
  }
  return next;
}

/** Chip color class by how hot the round was. */
export function heatClass(cp: number): string {
  if (cp < 1.5) return "border-danger/40 text-danger";
  if (cp < 3) return "border-border text-text-muted";
  if (cp < 10) return "border-win/40 text-win";
  return "border-gold/50 text-gold";
}
